<template>
	<div class="order-items-editor">
		<div class="page-subtitle">
      Order items:
    </div>
		<div class="items-autocomplete">
      <q-select name="selectedMenuItem"
                dense
                filled
                label="Select item to add"
                :options="availableProducts"
                v-model="selectedItem"
                use-input
                @filter="filterFn"
                :option-label="addItemLabel"
                id="selectedMenuItem">
      </q-select>

      <q-btn label="Add item" class="q-mt-sm" color="primary" icon="fas fa-circle-plus" :disable="!selectedItem.id" @click="addItem" />
		</div>

		<q-markup-table >
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Qty</th>
          <th>Price</th>
          <th>Options</th>
          <th>Del</th>
        </tr>
      </thead>
			<tbody>
				<tr v-for="(item, itemId) in order.details.items" :key="itemId">
          <td>
            {{index(itemId) + 1}}
          </td>
					<td class="order-item-title">
            <q-input v-model="item.title" dense filled hide-bottom-space label="Title" class="q-mb-sm" />
            <q-input hide-bottom-space type="textarea" label="Comment" v-model="item.comment" dense filled rows="2"/>
					</td>
					<td>
						<q-input type="number"
                     filled
                     dense
                     style="max-width: 60px"
					           min="1"
					           step="1"
                     hide-bottom-space
					           @change="updateTotalPrice"
					           v-model="item.qty"
						/>
					</td>
					<td class="price">
            <q-input type="number"
                     filled
                     dense
                     min="1"
                     step="1"
                     hide-bottom-space
                     @change="updateTotalPrice"
                     v-model="item.price"
            />
					</td>
          <td>
            <table class="options-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="option" v-for="(opt, index) in (item.options || [])" :key="index">
                  <td>
                    {{index + 1}}
                  </td>
                  <td>
                    <q-input v-model="opt.name" label="Name" dense filled hide-bottom-space />
                  </td>
                  <td>
                    <q-input v-model="opt.price" label="Price" dense filled hide-bottom-space @input="updateTotalPrice"/>
                  </td>
                  <td>
                    <q-btn dense flat icon="fas fa-trash-alt" @click="removeOption(item, index)" />
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="availableOptions(itemId) && availableOptions(itemId).length > 0">
                <tr>
                  <td colspan="4">
                    <q-select v-model="addOption"
                              dense
                              filled
                              label="Select option"
                              option-label="name"
                              @input="addOptionToOrderItem(item)"
                              :options="availableOptions(itemId)"
                    />
                  </td>
                </tr>
              </tfoot>
            </table>
          </td>
					<td>
						<q-btn dense flat color="negative" icon="fas fa-times" @click="removeItem(itemId)" />
					</td>
				</tr>
			</tbody>
		</q-markup-table>
	</div>
</template>

<script>
	export default {
		name: "OrderItemsEditor",
    props: {
		  order: {
		    required: true,
        type: Object
      }
    },
    data(){
      return {
        addOption: '',
        selectedItem: {},
        allAvailableProducts: [],
        availableProducts: [],
      }
    },
    mounted() {
			this.getAvailableProducts()
		},
		methods: {
      addOptionToOrderItem(item){
        item.options.push(this.addOption)
        this.addOption = ''

        this.updateTotalPrice()

        this.$forceUpdate()
      },
      removeOption(item, index){
        this.$q.dialog({
          message: "Are you sure want to remove this option?",
          cancel: true
        }).onOk(() => {
          item.options.splice(index, 1)
          this.updateTotalPrice()
        })
      },
		  index(itemId){
		    let keys = Object.keys(this.order.details.items)

        return keys.indexOf(itemId)
      },
		  addItemLabel(opt){
		    if(!opt.id){
		      return ''
        }

		    return `[${opt.category ? opt.category.name : ''}] ${opt.name}, ${opt.sku ? opt.sku + ',' : ''} $${opt.base_price}`
      },
      filterFn (val, update) {
        if (val === '') {
          update(() => {
            this.availableProducts = this.allAvailableProducts

            // with Quasar v1.7.4+
            // here you have access to "ref" which
            // is the Vue reference of the QSelect
          })
          return
        }

        update(() => {
          const needle = val.toLowerCase()
          this.availableProducts = this.allAvailableProducts.filter(v => {
                return v.name.toLowerCase().indexOf(needle) > -1
                    || v.sku.toLowerCase().indexOf(needle) > -1
                    || v.category.name.toLowerCase().indexOf(needle) > -1
          })
        })
      },
		  getAvailableProducts(){
		    this.axiosGet('/admin_products/listShort').then(r => {
		      this.allAvailableProducts = r.data
        })
      },
			addItem() {
				this.order.details.items = this.order.details.items ? this.order.details.items : {};

				let existingItem = this.order.details.items[this.selectedItem.id];

				if(existingItem){
					this.order.details.items[this.selectedItem.id].qty += 1
				} else {
					this.order.details.items[this.selectedItem.id] = this.selectedItem;
					this.order.details.items[this.selectedItem.id].qty = 1
					this.order.details.items[this.selectedItem.id].thumbnail = this.selectedItem.image
					this.order.details.items[this.selectedItem.id].title = this.selectedItem.name
					this.order.details.items[this.selectedItem.id].productId = this.selectedItem.id
				}

				this.updateTotalPrice();
				this.$forceUpdate();
			},
			removeItem(itemId){
		    this.$q.dialog({
          message: "Are you sure want to remove this item from order?",
          cancel: true
        }).onOk(() => {
          delete this.order.details.items[itemId];
          this.updateTotalPrice()
          this.$forceUpdate()
        })
			},
      availableOptions(itemId){
        let product = this.allAvailableProducts.filter(p => p.id == itemId)[0]

        if(!product) {
          return []
        }

        return product.options || []
      },
			updateTotalPrice(){
				let totalPrice = 0;
				let orderItem;

				for(let itemId in this.order.details.items){
				  orderItem = this.order.details.items[itemId]

					totalPrice += orderItem.price * orderItem.qty

          if(orderItem.options && orderItem.options.length){
           for (let opt of orderItem.options){
             if(opt.price){
               totalPrice += parseFloat(opt.price)
             }
           }
          }
				}

				this.order.price = totalPrice
				this.order.details.totalPrice = totalPrice
			}
		}
	}
</script>
